import { getSourcingRequirementDetail } from "@/apis/requirementManagement.api";
import { useQuery } from "@tanstack/react-query";
import type { RecordId } from "../type";

export function useSourcingRequirementQuery(recordId: RecordId) {
  const result = useQuery({
    queryKey: ["querySourcingRequirementDetail", recordId],
    queryFn: () => getSourcingRequirementDetail(recordId!),
    enabled: !!recordId,
  });

  if (!recordId) return;

  return result.data?.data.data;
}
